import { useRef, useState } from "react";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { StoreHighlightView } from "@/lib/api/types";
import { Modal, Button } from "@a2z/ui";
import { HighlightsForm } from "@/modules/settings/components/HighlightsForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  storeSlug: string;
  initialHighlights: StoreHighlightView[];
};

export function BrandingHighlightsSheet({
  isOpen,
  onClose,
  storeSlug,
  initialHighlights,
}: Props) {
  const t = useTranslations();

  // The form exposes its save function via this ref and keeps the parent
  // informed about dirty/submitting state so the sticky footer can react.
  const submitRef = useRef<(() => Promise<void>) | null>(null);
  const [isDirty, setIsDirty] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title={t(keys.seller.storeHighlightsTitle)}
      closeLabel={t(keys.common.cancel)}
      showFooterWhen={isDirty}
      footerActions={
        <Button
          variant="primary"
          size="md"
          disabled={isSubmitting}
          onClick={() => void submitRef.current?.()}
        >
          {isSubmitting ? t(keys.common.loading) : t(keys.common.save)}
        </Button>
      }
    >
      <HighlightsForm
        storeSlug={storeSlug}
        initialHighlights={initialHighlights}
        submitRef={submitRef}
        onDirtyChange={setIsDirty}
        onSubmittingChange={setIsSubmitting}
      />
    </Modal>
  );
}
